export default {
  USER: 'user',
  ADDRESS: 'address',
  PHONE: 'phone',
  ADMIN: 'admin',
  CLIENT: 'client',
  CLIENT_USER: 'client-user',
  CLIENT_TOKEN: 'client-token',
  CLIENT_THIRD_PARTIES: 'third-parties',
  JOB: 'job',
  REPORT: 'report',
  JOB_REPORT: 'job-report',
  ECOMMERCE_REPORT: 'ecommerce-report',
  ECOMMERCE_JOB_BOARD_REPORT: 'ecommerce-job-board-report',
  CLIENT_REPORT: 'client-report',
  CANDIDATE_REPORT: 'candidate-report',
  CREDIT_REPORT: 'credit-report',
  CONTRACT_REPORT: 'contract-report',
  JOB_BOARD_REPORT: 'job-board-report',
  JOB_ALERT: 'job-alert',
  JOB_BOARD: 'jobboard',
  LOG: 'log',
  JOB_FOLLOWER: 'job-follower',
  TYPE_AHEAD: 'type_ahead',
  EMAIL: 'email',
  EMAIL_SCHEDULE: 'email-schedule',
  EMAIL_CONFIG: 'email-config',
  CANDIDATE: 'candidate',
  APPLICANTS: 'applicant',
  RESUME: 'resume',
  ORDER: 'order',
  INVOICE: 'invoice',
  INVOICE_LINE: 'invoice-line',
  LANDING_PAGE: 'landing-page',
  SETTINGS: 'settings',
  TRANSLATION: 'translation',
  LANGUAGE: 'language',
  COUNTRY:'country',
  JOB_CREATE_PRODUCT:'product',
  DASHBOARD: 'dashboard',
  ROLE: 'roles',
  ORGANIZATION: 'organisation',
  ORGANIZATION_INFO: 'organisation-info',
  JOB_INFO: 'job-info',
  CREDIT: 'credit',
  CMS: 'cms',
  NEWSLETTER: 'newsletter',
  CONTRACT: 'contract',
  SEGMENT: 'segment',
  SEGMENT_GROUP: 'segments-group',
  SUGGESTION: 'suggestion',
  PLACEHOLDER: 'placeholder',
  SITE_ADMIN: 'site-admin',
  THIRD_PARTY: 'third-partie',
  PRODUCT:'product',
  SUBSCRIPTION:'subscription',
  PAYMENT_TYPE:'payment-type',
  PRODUCT_RULE:'product_rule',
  VOUCHER:'voucher'
}
